<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OFMp5D/cover.jpeg?1684305845024" alt="This image is the cover for the book Part-time King In Three Realms, Volume 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Part-time King In Three Realms, Volume 2
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>Ye Tao obtained the part-time software from the Three Realms. Through the first part-time job, he helped one of the Eight Immortals, Immortal Lady He, with the rewards and treasures, which included Lu Dongbin's Pure Yang Sword Courage and a wisp of his comprehension of the laws of the sword.</strong></p><p><strong> </strong>After that, he returned to the city to mingle with the wind and water, walking towards the peak of life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yi YanQiNian, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ad7844b